var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" To install Vuetify, type "),_c('kbd',[_vm._v("npm install vuetify")]),_vm._v(" into your console. Once complete, type "),_c('kbd',[_vm._v("cd "),_c('code',[_vm._v("<project name>")])]),_vm._v(" and run "),_c('kbd',[_vm._v("npm install")])])
}]

export { render, staticRenderFns }